import {
  Component,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  Renderer2,
  ElementRef,
  SecurityContext,
} from '@angular/core'
import { DomSanitizer } from '@angular/platform-browser'
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core'
import { CheckoutService } from '../../checkout.service'
import { Discounts } from '../../../../../../models/discounts.model'

// export enum Discounts {
//   ZRGD = 'Region Discount',
//   ZCUD = 'Customer Discount',
//   ZQSD = 'Product/Volume Discount',
//   ZLVD = 'Product/Volume Discount',
//   ZHVD = 'Product/Volume Discount',
//   ZSQD = 'Stock Order Discount',
//   ZSVD = 'Stock Order Discount',
//   ZSD1 = 'Manual Discount Adjustment',
//   ZSD2 = 'Manual Discount Adjustment',
//   ZDSH = 'Manual Adder Adjustment',
//   ZEDC = 'Express Delivery Adder',
//   ZDOA = 'Coupon',
// }

@Component({
  standalone: false,
  selector: 'vs-line-item',
  templateUrl: './line-item.component.html',
  styleUrls: ['./line-item.component.scss'],
})
export class LineItemComponent implements OnInit {
  cartOrderReviewObj: any = {}
  breakUp = false
  public lineItems
  lineItemsObj: any
  basePrice?: any

  @ViewChild('breakupContent')
  breakupContent

  @ViewChild('viewBreakupLink')
  viewBreakupLink

  constructor(
    private checkoutService: CheckoutService,
    private globalMessageService: GlobalMessageService,
    private cRef: ChangeDetectorRef,
    private renderer: Renderer2,
    public elRef: ElementRef,
    private domSanitizer: DomSanitizer
  ) {
    this.domSanitizer.sanitize(
      SecurityContext.NONE,
      this.renderer.listen(document, 'click', this.bodyClick.bind(this))
    )
  }

  ngOnInit(): void {
    this.checkoutService.addressObjData.subscribe(
      (data) => {
        this.cartOrderReviewObj = data
        for (let i = 0; i < this.cartOrderReviewObj?.entries?.length; i++) {
          this.cartOrderReviewObj.entries[i].showBreakup = false
        }
        this.lineItemsObj = this.cartOrderReviewObj.entries
      },
      (error) => {
        this.globalMessageService.add(
          error,
          GlobalMessageType.MSG_TYPE_ERROR,
          5000
        )
        window.scrollTo(0, 0)
      }
    )
  }

  closeMenu(event) {
    this.breakUp = false
  }

  getDiscountName(code) {
    let discountName = Discounts[code]
    if (code.indexOf('Action') > -1) {
      discountName = 'Coupon'
    }
    return discountName
  }

  showBreakUp(indexVal) {
    for (let i = 0; i < this.cartOrderReviewObj?.entries?.length; i++) {
      if (indexVal == i) {
        this.cartOrderReviewObj.entries[i].showBreakup =
          !this.cartOrderReviewObj.entries[i].showBreakup
      } else {
        this.cartOrderReviewObj.entries[i].showBreakup = false
      }
    }
  }

  bodyClick() {
    if (
      this.viewBreakupLink &&
      !this.viewBreakupLink.nativeElement.contains(event.target) &&
      this.breakupContent &&
      !this.breakupContent.nativeElement.contains(event.target)
    ) {
      this.breakUp = false
      this.cRef.detectChanges()
    }
  }
}
